export const PACKAGES = [
  {
    n: 1,
    price: 23,
    minGuests: 50,
    tray: "Large Tray · 60 pcs",
    items: ["2 Appetizers", "Assorted Naans or Roti", "2 Gravy Items", "1 Fry Item", "2 Rice Items", "Sambhar or Any Daal", "Yogurt", "Vadiyalu / Fryums", "Roti Pachadi", "Pickle", "1 Dessert"],
    recommended: "Mixed Pakoda, Masala Vada · Butter Naan / Garlic Naan · Paneer Butter Masala, Eggplant Gravy · Tindora, Bhendi or Eggplant Fry · Veg Biryani, White Rice · Drumstick Sambhar or Mango Daal · Gulab Jamun, Rasmalai or Carrot Halwa",
  },
  {
    n: 2,
    price: 25,
    minGuests: 75,
    tray: "Medium Tray · 32 oz / 16 oz",
    featured: true,
    items: ["3 Appetizers", "Assorted Naans", "3 Gravy Items", "Fried Item", "Poriyal Item", "2 Rice Items", "1 Daal / Sambhar", "Yogurt", "Vadiyalu", "Roti Pachadi", "Pickle", "2 Desserts"],
    recommended: "Gobi 65, Mixed Pakoda & Masala Vada · Butter Naan / Garlic Naan · Paneer Gravy, Eggplant Gravy · Vegetable Korma · Beans Poriyal · Vegetable Biryani / White / Yogurt Rice · Mango / Gongura Daal · Gulab Jamun / Rasmalai / Carrot Halwa",
  },
  {
    n: 3,
    price: 35,
    minGuests: 100,
    tray: "Large Tray",
    items: ["1 Welcome Drink", "4 Appetizers", "Assorted Naans", "3 Gravy Items", "Fried Item", "Poriyal Item", "2 Rice Items", "Daal", "Drumstick Sambhar", "Yogurt / Vadiyalu", "Roti Pachadi", "Pickle", "Salad", "2 Desserts"],
    recommended: "Rose Milk / Mango Lassi / Tea / Coffee · Veg Fingers / Gobi 65 / Pakoda & Vada · Butter Naan / Roti · Paneer Gravy / Eggplant Gravy / Veg Korma · Veg Biryani / White & Yogurt Rice · Cucumber / Sprouted Moongdal Salad · Gulab Jamun / Rasmalai / Carrot Halwa",
  },
];

export const CATERING_NOTES = [
  "Setup $150 — includes sternos, chafing dishes & aluminium trays",
  "Helpers $150 each for 4 hours (setup 1 hr + serving 3 hrs)",
  "Extra item +$2.00 per person",
  "Free delivery · We cater up to 5,000 people",
  "Jain & Swaminarayan food (no onion, no garlic)",
];
